// extracted by mini-css-extract-plugin
module.exports = {"div":"CardDetails_div__adUew"};